module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_9005.0ee00d30.png";